import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getLandDocuments(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENTS,
		options
	)
}

function _getLandDocument(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT,
		options
	)
}

function _createLandDocument(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].CREATE_LAND_DOCUMENT,
		options
	)
}

function _putLandDocument(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PUT_LAND_DOCUMENT,
		options
	)
}

function _patchLandDocument(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PATCH_LAND_DOCUMENT,
		options
	)
}

function _deleteLandDocument(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].DELETE_LAND_DOCUMENT,
		options
	)
}

function _getLandDocumentPreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_PREVIEW,
		options
	)
}

function _getLandDocumentPopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.LAND_DOCUMENTS,
		ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENTS]: _getLandDocuments,

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT]: _getLandDocument,
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_PREVIEW]: _getLandDocumentPreview,
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_POPUP]: _getLandDocumentPopup,

	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].CREATE_LAND_DOCUMENT]: _createLandDocument,
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PUT_LAND_DOCUMENT]: _putLandDocument,
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PATCH_LAND_DOCUMENT]: _patchLandDocument,
	[ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].DELETE_LAND_DOCUMENT]: _deleteLandDocument,
}